<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.periodoContabil"
        ref="RkmDataTable"
        sort-by="inicio"
    >
        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click="destroy(item)"
                authorize="destroy-web-service-almoxarifado-cliente-periodo-contabil"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            periodoContabil: this.getConectaSusRepository('webService.almoxarifado.cliente.periodoContabil'),
        }
    },
    data: () => ({
        fields: [
            {key: 'inicio', label: 'Início', name: 'periodoContabil.inicio', searchable: true, sortable: true},
            {key: 'fim', label: 'Fim', name: 'periodoContabil.fim', searchable: true, sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(item) {
            const destroy = () => this.repositories.periodoContabil.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o período contábil?', destroy, this.handleError)
        },
    },
    mixins: [error, repository],
}
</script>